import { Route } from '@angular/router';
import { AppUrls } from '../../../../../common/dto/app-urls';
import { TrendsRoute } from './trends/trends.route';
import { VisitorsRoute } from './visitors/visitors.route';

export const DiscoverRoute: Route = {
  path: AppUrls.Dashboard._.Discover.relativeUrl,
  children: [
    VisitorsRoute,
    TrendsRoute,
    {
      path: '**',
      redirectTo: VisitorsRoute.path,
    },
  ],
};
